import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import OrderNotesDisplayer from '../OrderTable/TableComponents/OrderNotesDisplayer'
import HeaderOrderTotal, { FooterRowConfigInputBaseProps, HeaderOrderTotalNew } from '../OrderTable/TableComponents/OrderTotal/Components/HeaderOrderTotal'
import NotesOrderModal from '../OrderTable/TableComponents/OrderTotal/Components/NotesOrderModal'
import { OnChangeOrderTableLogicProps } from '../OrderTable/useOrderTableHooks'
import FooterOrderTotal, { FooterOrderTotalNew } from './FooterOrderTotal'
import { InputTableLayoutData, OrderHeaderURLs } from '../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { UserPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { FooterTotalsResult, HeaderDataCalculate } from '@teinor/erp/types/company/order/general'
import { useState, useCallback } from 'react'
import { CalculateParamsTy } from '../../../../../baseComponents/Displays/DisplayPrice/types'
import { getPreparePricesConfigParam } from '../../../../../utils/reducers/getters'
import { ITLayoutTableModalOpen, ITLayoutTableModalOpenSetTy } from '../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { FooterConfigShippingComponentBaseProps } from './FooterOrderTotal/Components/FooterOrderLeftComponent'
import ModalOrderPaymentMethodConnect from '../OrderTable/TableComponents/ModalsOrderTable/ModalOrderPaymentMethod'
import { sellInvoiceStatusInversed } from '@teinor/erp/types/company/order/sell/sellInvoice'
import useEditDeleteModal from '../../../../../utils/hooks/useEditDeleteModal'


type OrderTotalProps = OrderTotalLogicProps & OnChangeOrderTableLogicProps & {
    CurrencyId: string
    hideNotes?: boolean
    hideLeftFooter?: boolean
    hideFinancialRows?: boolean
    costs: TwinDictionary
    orderHeaderURLs: OrderHeaderURLs
    userPermissions: UserPermissions
    skipEdit: boolean
    orderStatusDict: TwinDictionary
    modelId: string
    isReadOnly?: boolean
    totalsOrderTableData: FooterTotalsResult
}

const OrderTotal: React.FC<OrderTotalProps> = ({ CurrencyId, completeData, hideNotes, costs, orderHeaderURLs, userPermissions, skipEdit, orderStatusDict, modelId, totalsOrderTableData, ...rest }) => {
    const { show, handleShow, openModal, setOpenModal, haveNotes, headerDataCalculate } = useOrderTotalLogic({ completeData })
    return (
        <div>
            <HeaderOrderTotal {...{ totalsOrderTableData, OrderId: completeData?.header?.id, show, handleShow, getCompleteData: rest.getCompleteData, CurrencyId, orderStatus: completeData.header.status, OrderFinancialRows: completeData.header.OrderFinancialRows, setOpenModal, haveNotes, hideNotes, orderHeaderURLs, userPermissions, skipEdit, orderStatusDict, total_payed: completeData.header.total_payed, completeData }} />
            {show ? <FooterOrderTotal {...{ totalsOrderTableData: totalsOrderTableData, CurrencyId, headerDataCalculate, costs, orderHeaderURLs }} /> : null}
            {haveNotes ? <OrderNotesDisplayer notes={completeData.header.notes} setOpenModal={setOpenModal} /> : null}
            {openModal?.type === 'create' ? <NotesOrderModal {...{ completeData, ...rest }} setOpened={() => setOpenModal(null)} /> : null}
            {openModal?.type === 'edit' ? <ModalOrderPaymentMethodConnect allRowData={{ url: '/api/app/order/sell/sellInvoice/assignPaymentMethodToSellInvoice' }} isReadOnly={sellInvoiceStatusInversed['creating'] !== completeData?.header?.status} headerData={completeData.header} {...{ totalsOrderTableData, ...rest }} totalsOrderTableData={totalsOrderTableData} setOpened={() => setOpenModal(null)} /> : null}
        </div>
    )
}

export interface OrderTotalLogicProps {
    completeData: InputTableLayoutData
}

const useOrderTotalLogic = ({ completeData }: OrderTotalLogicProps) => {
    const [show, setShow] = useState<boolean>(false)
    const { openModal, setOpenModal } = useEditDeleteModal()
    const haveNotes = completeData?.header?.notes?.length
    const calculateParams = getPreparePricesConfigParam() as CalculateParamsTy
    const headerDataCalculate: HeaderDataCalculate = {
        OrderCosts: completeData.header?.OrderCosts,
        ParamsRoundingDecimals: calculateParams,
        total_recharge_after: completeData.header?.total_recharge_after,
        OrderShipping: completeData.header?.OrderShipping,
        isFinished: completeData.header.isFinished,
        OrderAccounts: completeData.header?.OrderAccounts
    }

    const handleShow = useCallback(() => {
        setShow((oldTotal) => !oldTotal)
    }, [setShow])

    return { show, handleShow, openModal, setOpenModal, haveNotes, headerDataCalculate }
}

interface OrderTotalNewProps extends OrderTotalProps {
    setOpenModal: ITLayoutTableModalOpenSetTy;
    openModal: ITLayoutTableModalOpen;
    FooterOrderRowShortComponent: React.FC<FooterRowConfigInputBaseProps>
    FooterOrderLeftConfigComponent: React.FC<FooterConfigShippingComponentBaseProps>
    totalsOrderTableData: FooterTotalsResult
}

export const OrderTotalNew: React.FC<OrderTotalNewProps> = ({ CurrencyId, completeData, hideNotes, costs, orderHeaderURLs, userPermissions, skipEdit, orderStatusDict, setOpenModal, hideLeftFooter, isReadOnly, FooterOrderRowShortComponent, modelId, totalsOrderTableData, ...rest }) => {
    const { show, handleShow, headerDataCalculate } = useOrderTotalLogic({ completeData })
    const baseProps = {
        totalsOrderTableData, OrderId: completeData?.header?.id, CurrencyId, orderStatus: completeData.header.status, OrderFinancialRows: completeData.header.OrderFinancialRows, orderHeaderURLs, skipEdit, orderStatusDict, costs, headerDataCalculate, setOpenModal, headerData: completeData?.header, isReadOnly,
        hideLeftFooter, 
    }
    return (
        <div>
            <HeaderOrderTotalNew {...{ show, handleShow, completeData, getCompleteData: rest.getCompleteData, FooterOrderRowShortComponent, modelId, ...baseProps }} />
            {show ? <FooterOrderTotalNew {...{ completeData, hideNotes, userPermissions, modelId, total_payed: completeData.header.total_payed, ...baseProps, ...rest }} /> : null}
        </div>
    )
}

export default OrderTotal